export const switchProps = {
    "& .MuiSwitch-track": {
        backgroundColor: "var(--selected) !important"
    },
    "& .Mui-checked": {
        color: "var(--selected) !important"
    }
}